import { Metadata } from 'next';
import TermsStatsClient from './client';

export const metadata: Metadata = {
    title: '약관 통계 - InsuWiki Admin',
};

export default function TermsStatsPage() {
    return (
        <div className="min-h-screen bg-slate-50">
            <div className="max-w-6xl mx-auto px-4 py-8">
                <TermsStatsClient />
            </div>
        </div>
    );
}
